module.exports = __webpack_public_path__ + "img/navon.d80092e.png";